// Created: 2026-02-21 by Douglas — unified notification bell
// Last edited: 2026-04-11 by Douglas — refactored to open ActivityFeed slide-out panel

import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { IconBell } from '@tabler/icons-react';
import ActivityFeed, { useUnreadCount } from './ActivityFeed';

/**
 * UnifiedNotificationBell
 *
 * Thin bell icon that opens the ActivityFeed slide-out panel.
 * Uses useUnreadCount hook for badge count + urgency color.
 */
export default function UnifiedNotificationBell() {
  const [feedOpen, setFeedOpen] = useState(false);
  const { count: totalUnread, hasUrgent } = useUnreadCount();
  const [newFlash, setNewFlash] = useState(false);

  const bellColor = hasUrgent
    ? 'text-red-400 hover:text-red-300 hover:bg-red-400/20'
    : totalUnread > 0
      ? 'text-[#AEA36D] hover:text-[#AEA36D]/80 hover:bg-[#AEA36D]/20'
      : 'text-gray-500 hover:text-gray-400 hover:bg-gray-700/50';

  const bellAnimate = hasUrgent && totalUnread > 0 ? 'animate-pulse' : '';

  return (
    <>
      <button
        onClick={(e) => {
          e.stopPropagation();
          setFeedOpen(prev => !prev);
        }}
        className={`relative p-1.5 transition-all duration-200 rounded-lg ${bellColor} ${newFlash ? 'ring-2 ring-[#AEA36D]' : ''}`}
        title={totalUnread > 0 ? `${totalUnread} unread notifications` : 'No new notifications'}
      >
        <IconBell className={`h-5 w-5 ${bellAnimate}`} />
        {totalUnread > 0 && (
          <span className={`absolute -top-1 -right-1 h-4 min-w-4 px-1 text-[10px] font-bold rounded-full flex items-center justify-center ${
            hasUrgent ? 'bg-red-500 text-white' : 'bg-[#AEA36D] text-black'
          }`}>
            {totalUnread > 99 ? '99+' : totalUnread}
          </span>
        )}
      </button>

      {createPortal(
        <ActivityFeed open={feedOpen} onClose={() => setFeedOpen(false)} />,
        document.body
      )}
    </>
  );
}
